import { graphql } from 'react-relay';

export const languagePreferenceFragment = graphql`
    fragment LanguagePreference_component on LanguagePreference {
        info {
            ...CategoryInfo_info
        }
        items {
            label
            filtervalue
        }
        categoryname
    }
`;
